<button
  type="button"
  (click)="toggle()"
  [attr.aria-pressed]="isDark()"
  [attr.aria-label]="action()"
  [title]="action()"
  class="inline-flex size-9 items-center justify-center rounded-md bg-app-card text-app-ink ring-1 ring-app-line/40 ring-inset hover:bg-app-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-xpo-blue"
>
  @if (isDark()) {
    <!-- Moon: the dark theme is in effect. -->
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="size-5">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.455 2.004a.75.75 0 0 1 .26.77 7 7 0 0 0 9.958 7.967.75.75 0 0 1 1.067.853A8.5 8.5 0 1 1 6.647 1.921a.75.75 0 0 1 .808.083"
      />
    </svg>
  } @else {
    <!-- Sun: the light theme is in effect. -->
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="size-5">
      <path
        d="M10 2a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1A.75.75 0 0 1 10 2M10 15.5a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75M10 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8M2.75 9.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5zM15.5 10a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75M4.399 4.399a.75.75 0 0 1 1.06 0l.708.707a.75.75 0 1 1-1.061 1.06l-.707-.707a.75.75 0 0 1 0-1.06M14.541 13.48a.75.75 0 0 0-1.06 1.06l.706.708a.75.75 0 0 0 1.061-1.061zM5.46 14.541a.75.75 0 0 1 0-1.061l.706-.707a.75.75 0 1 1 1.061 1.06l-.707.708a.75.75 0 0 1-1.06 0M13.48 5.46a.75.75 0 0 0 1.06 0l.708-.707a.75.75 0 0 0-1.061-1.06l-.707.706a.75.75 0 0 0 0 1.061"
      />
    </svg>
  }
</button>
